import { fetcher } from "helpers/fetcher";

import { TDeleteJobListingReq, TDeleteJobListingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteJobListing = async (payload: TDeleteJobListingReq) => {
  return await fetcher<TDeleteJobListingRes, TDeleteJobListingReq["data"]>(
    ENDPOINT.CORPORATION.DELETE_JOB_LISTING,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.DELETE_JOB_LISTING.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const mutationDeleteJobListing = async (
  payload: TDeleteJobListingReq
) => {
  return (await deleteJobListing(payload)).data;
};

mutationDeleteJobListing._key = (payload: TDeleteJobListingReq) => [
  ENDPOINT.CORPORATION.DELETE_JOB_LISTING.url,
  payload,
];
